import {
  Body,
  Box,
  Flex,
  Heading,
  Image,
  LinkBox,
  LinkOverlay,
  Sheet,
  Spacer,
  VStack,
} from '@hover/blueprint';
import React from 'react';

import { HomeownerBranchLink } from 'src/modules/homeownerApp/constants/scans';
import { useGetAppLink } from 'src/modules/homeownerApp/hooks';
import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import exampleModel from 'assets/img/homeownerApp/scan/example-model.jpg';
import scanHome from 'assets/img/homeownerApp/scan/scan-house.jpg';

const InfoModule = ({
  image,
  subHeading,
  heading,
  body,
}: {
  image: string;
  subHeading: string;
  heading: string;
  body: string;
}) => (
  <VStack alignItems="flex-start" flex="1" gap={400}>
    <Image alt="scan-home" objectFit="cover" src={image} width="100%" />
    <Flex direction="column">
      <Heading m={0} textStyle="headingXs">
        {subHeading}
      </Heading>
      <Heading m={0} mt={100} textStyle="headingMedium">
        {heading}
      </Heading>
      <Body color="neutral.600" m={0} mt="400" textStyle="bodySmall">
        {body}
      </Body>
    </Flex>
  </VStack>
);

export const ScanLearnMore = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { onGetAppClick } = useGetAppLink();

  return (
    <Sheet.Contents maxHeight="100vh" overflowY="auto">
      <VStack
        alignItems="flex-start"
        maxW={{ base: 'unset', tablet: '888px' }}
        pb={{
          base: 'calc(var(--motion-overflow) + var(--hover-space-600))',
          tablet: 1000,
        }}
        position="relative"
        pt={{ base: 600, tablet: 1000 }}
        px={{ base: 500, tablet: 1000 }}
      >
        <Spacer display={{ tablet: 'none' }} py="400" />
        <VStack
          alignItems="flex-start"
          gap="400"
          maxWidth={{ base: 'unset', tablet: '456px' }}
          pb="400"
        >
          <Heading
            m={0}
            textStyle={{
              base: 'headingLargeWithCapsize',
              tablet: 'headingXlWithCapsize',
            }}
          >
            {t('scan.learnMore.measureAndModel')}
          </Heading>
          <Body mt="0 !important" textStyle="bodySmall">
            {t('scan.learnMore.justAFewPhotos')}
          </Body>
        </VStack>
        <Box display={{ base: 'none', tablet: 'flex' }} pb={900} pt={100}>
          <Button onClick={onGetAppClick} variant="primary">
            {t('scan.learnMore.getTheApp')}
          </Button>
        </Box>

        <Box
          flexDirection={{ base: 'column', tablet: 'row' }}
          gap="500"
          mt="0 !important"
        >
          <InfoModule
            body={t('scan.learnMore.instructions')}
            heading={t('scan.learnMore.takePhotos')}
            image={scanHome}
            subHeading={t('scan.learnMore.howItWorks')}
          />
          <InfoModule
            body={t('scan.learnMore.planYourProject')}
            heading={t('scan.learnMore.seeYourHome')}
            image={exampleModel}
            subHeading={t('scan.learnMore.whatYouGet')}
          />
        </Box>

        <Box
          alignSelf="flex-end"
          bottom="0px"
          display={{ base: 'inline', tablet: 'none' }}
          padding={600}
          position="sticky"
          width="100%"
        >
          <LinkBox>
            <LinkOverlay
              href={HomeownerBranchLink}
              target="_blank"
              textDecoration="none"
            >
              <Button
                size="large"
                variant="primary"
                width={{ base: '100%', tablet: 'auto' }}
              >
                {t('scan.downloadAppToScan')}
              </Button>
            </LinkOverlay>
          </LinkBox>
        </Box>
      </VStack>
    </Sheet.Contents>
  );
};
